import { Repository } from "./0Repository";
import { toMap, registerDataRepository } from "../../../HA";

export class Data extends Repository {

    public saveForm(d: Map<string, any> | FormData) {
        return this.request(toMap({
            data: d,
            url: "/ha/form",
        }));
    }

    public fetchData(d: Map<string, any> | FormData) {
        return this.request(toMap({
            data: d,
            url: "/ha/app",
        }));
    }

    public saveData(d: Map<string, any> | FormData) {
        return this.request(toMap({
            data: d,
            url: "/ha/app",
        }));
    }
}

// Remplit le slot DataRepository de HA.ts au chargement du module (cf.
// getDataRepository). Le boot side-effect-importe ce module via main.ts.
registerDataRepository(Data);
